
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Voice() {
  const testimonials = [
    {
      id: 1,
      company: '京都〇〇株式会社',
      representative: '物流部長 田中様',
      industry: '製造業',
      service: '一般貨物運送事業',
      period: '2024年1月より利用',
      rating: 5,
      title: '配送効率が劇的に改善されました',
      comment: 'SUNFIELDさんにお願いしてから、配送時間が大幅に短縮され、コストも30%削減できました。若いスタッフの皆さんの熱意と迅速な対応には本当に感謝しています。特に急な配送依頼にも柔軟に対応していただけるのが助かります。',
      improvements: [
        '配送時間50%短縮',
        'コスト30%削減',
        '顧客クレーム0件'
      ],
      avatar: 'Professional middle-aged Japanese businessman in manufacturing industry, confident smile, business portrait photography, clean corporate background'
    },
    {
      id: 2,
      company: 'オンラインショップ〇〇',
      representative: '代表取締役 佐藤様',
      industry: 'EC事業',
      service: '軽貨物運送事業',
      period: '2024年3月より利用',
      rating: 5,
      title: '顧客満足度が向上し売上もアップ',
      comment: '当日配送サービスの品質が素晴らしく、お客様からの評価が格段に上がりました。配送状況もリアルタイムで確認でき、安心してお任せできます。おかげで売上も20%向上し、今では欠かせないパートナーです。',
      improvements: [
        '当日配送率99%達成',
        '顧客満足度向上',
        '売上20%アップ'
      ],
      avatar: 'Young Japanese female entrepreneur in e-commerce business, professional business attire, modern office setting, confident business portrait'
    },
    {
      id: 3,
      company: '〇〇スーパーチェーン',
      representative: '店舗運営部 山田様',
      industry: '小売業',
      service: '店舗間配送',
      period: '2024年2月より利用',
      rating: 5,
      title: '店舗運営がスムーズになりました',
      comment: 'SUNFIELDさんの柔軟な対応のおかげで、複数店舗間の商品配送が非常にスムーズになりました。ルート最適化により配送コストも40%削減され、経営効率が大幅に改善されました。スタッフの対応も丁寧で信頼できます。',
      improvements: [
        'ルート最適化実現',
        'コスト40%削減',
        '配送精度99.5%'
      ],
      avatar: 'Experienced Japanese retail manager in professional attire, standing in modern retail environment, business leadership portrait'
    }
  ];

  const satisfactionStats = [
    {
      metric: '総合満足度',
      score: '4.9',
      maxScore: '5.0',
      percentage: 98
    },
    {
      metric: '配送品質',
      score: '4.8',
      maxScore: '5.0',
      percentage: 96
    },
    {
      metric: '対応スピード',
      score: '4.9',
      maxScore: '5.0',
      percentage: 98
    },
    {
      metric: 'スタッフ対応',
      score: '5.0',
      maxScore: '5.0',
      percentage: 100
    }
  ];

  const benefits = [
    {
      icon: 'ri-time-line',
      title: '配送時間短縮',
      description: '平均40%の配送時間短縮を実現',
      count: '95%'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'コスト削減',
      description: '物流費用を平均30%削減',
      count: '89%'
    },
    {
      icon: 'ri-shield-check-line',
      title: '品質向上',
      description: '配送精度99%以上を維持',
      count: '100%'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'サービス向上',
      description: '24時間対応で満足度向上',
      count: '92%'
    }
  ];

  const renderStars = (rating: number) => {
    return [...Array(5)].map((_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400 text-xl`}
      ></i>
    ));
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/27cdcbcc35e8d02ee3613849c4ff3968.jpeg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">お客様の声</h1>
          <p className="text-xl text-blue-200">Customer Voice</p>
        </div>
      </section>

      {/* 満足度統計 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              顧客満足度
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              実際にサービスをご利用いただいたお客様からの評価統計
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {satisfactionStats.map((stat, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 text-center border border-blue-200">
                <h3 className="font-bold text-blue-900 mb-4">{stat.metric}</h3>
                <div className="text-4xl font-bold text-blue-700 mb-2">
                  {stat.score}
                  <span className="text-lg text-gray-600">/{stat.maxScore}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                  <div 
                    className="bg-yellow-400 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${stat.percentage}%` }}
                  ></div>
                </div>
                <p className="text-gray-600 text-sm">{stat.percentage}%の高評価</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* お客様の声詳細 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              導入事例とお客様の声
            </h2>
            <p className="text-xl text-gray-600">
              実際にサービスをご利用いただいているお客様からのリアルな声
            </p>
          </div>

          <div className="space-y-12">
            {testimonials.map((testimonial, index) => (
              <div key={testimonial.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                <div className={`bg-white rounded-xl shadow-lg p-8 ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                  <div className="flex items-center mb-6">
                    <img
                      src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg$%7Btestimonial.avatar%7D&width=80&height=80&seq=avatar-${testimonial.id}&orientation=squarish`}
                      alt={testimonial.representative}
                      className="w-16 h-16 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h3 className="font-bold text-blue-900 text-lg">{testimonial.company}</h3>
                      <p className="text-gray-600">{testimonial.representative}</p>
                      <div className="flex items-center mt-1">
                        {renderStars(testimonial.rating)}
                      </div>
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <div className="flex flex-wrap gap-2 mb-4">
                      <span className="bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-sm">
                        {testimonial.industry}
                      </span>
                      <span className="bg-green-100 text-green-900 px-3 py-1 rounded-full text-sm">
                        {testimonial.service}
                      </span>
                    </div>
                    <p className="text-gray-500 text-sm mb-2">{testimonial.period}</p>
                  </div>

                  <h4 className="text-xl font-bold text-blue-900 mb-4">
                    "{testimonial.title}"
                  </h4>
                  
                  <p className="text-gray-700 leading-relaxed mb-6 italic">
                    "{testimonial.comment}"
                  </p>

                  <div className="space-y-2">
                    <h5 className="font-semibold text-blue-900">導入効果:</h5>
                    <ul className="space-y-1">
                      {testimonial.improvements.map((improvement, improvementIndex) => (
                        <li key={improvementIndex} className="flex items-center text-sm text-gray-700">
                          <i className="ri-check-line text-green-500 mr-2"></i>
                          {improvement}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                  <img
                    src={`https://readdy.ai/api/search-image?query=Professional%20$%7Btestimonial.industry.toLowerCase%28%29%7D%20business%20operation%20with%20logistics%20improvement%2C%20modern%20workplace%20with%20efficient%20transportation%20service%2C%20successful%20business%20partnership%20concept&width=600&height=400&seq=testimonial-${testimonial.id}&orientation=landscape`}
                    alt={`${testimonial.company}様の事例`}
                    className="rounded-xl shadow-lg w-full h-auto object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 導入効果統計 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              導入効果統計
            </h2>
            <p className="text-xl text-gray-600">
              お客様が実感している主な導入効果
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-xl p-8 mb-6">
                  <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${benefit.icon} text-2xl text-blue-900`}></i>
                  </div>
                  <div className="text-3xl font-bold text-white mb-2">
                    {benefit.count}
                  </div>
                  <div className="text-blue-200 font-semibold">
                    のお客様が実感
                  </div>
                </div>
                <h3 className="font-bold text-blue-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 業界別満足度 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              業界別満足度
            </h2>
            <p className="text-xl text-gray-600">
              各業界でのサービス満足度
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { industry: '製造業', satisfaction: 98, clients: 15, icon: 'ri-settings-line' },
              { industry: 'EC事業', satisfaction: 96, clients: 12, icon: 'ri-shopping-cart-line' },
              { industry: '小売業', satisfaction: 97, clients: 10, icon: 'ri-store-line' },
              { industry: '物流業', satisfaction: 95, clients: 8, icon: 'ri-truck-line' },
              { industry: '食品業', satisfaction: 99, clients: 6, icon: 'ri-restaurant-line' },
              { industry: '建設業', satisfaction: 94, clients: 5, icon: 'ri-building-line' }
            ].map((industry, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className={`${industry.icon} text-blue-900 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-blue-900">{industry.industry}</h3>
                    <p className="text-gray-600 text-sm">{industry.clients}社でご利用</p>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-700">満足度</span>
                    <span className="font-bold text-blue-900">{industry.satisfaction}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-yellow-400 h-2 rounded-full transition-all duration-300"
                      style={{ width: `${industry.satisfaction}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 推薦状 */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
            継続利用率100%の信頼
          </h2>
          <div className="bg-white rounded-xl p-8 mb-8">
            <div className="flex justify-center mb-4">
              {renderStars(5)}
            </div>
            <p className="text-lg text-gray-700 italic mb-6 leading-relaxed">
              "SUNFIELDさんは、単なる配送業者ではありません。私たちのビジネスパートナーとして、常にお客様の立場に立って考え、最適なソリューションを提供してくれます。若いチームの熱意と確実な実行力で、私たちの物流課題を次々と解決してくれています。"
            </p>
            <div className="text-blue-900">
              <p className="font-bold">〇〇物流協会</p>
              <p className="text-sm">会長 鈴木様</p>
            </div>
          </div>
          <p className="text-blue-200 mb-8">
            現在ご利用いただいている全てのお客様が継続してサービスをご利用いただいています。
          </p>
          <Link
            to="/contact"
            className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors duration-200 inline-flex items-center whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            あなたも満足度の高いサービスを体験
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
